import {
  AspectRatioProps as MantineAspectRatioProps,
  AspectRatio as MantineAspectRatio,
} from '@mantine/core';

export type AspectRatioProps = MantineAspectRatioProps;

export const AspectRatio = MantineAspectRatio;

AspectRatio.displayName = 'AspectRatio';
